var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$tc("Bundle", 1),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      draggable: !_vm.loading && !_vm.dragIsDisabled,
      height: 165
    },
    on: {
      close: _vm.closeBundleWindow,
      changePosition: function($event) {
        return _vm.$emit("changeBundleWindowPosition", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [_c("BundleSVG", { staticClass: "floating-container-svg" })]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c("div", { staticClass: "floating-tool-content" }, [
              _c(
                "div",
                { staticClass: "bundle-objects-div scroll-fire-fox" },
                [
                  _c("HighlightedBox", {
                    attrs: {
                      "bad-object": _vm.badObject,
                      "is-visible": _vm.showInstruction,
                      message: _vm.currentInstruction
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right", margin: "0" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "multi-selection-checkbox",
                        attrs: {
                          label: _vm.$i18n.t("DontUsePathwaysIgnored"),
                          color: "accent",
                          ripple: false
                        },
                        model: {
                          value: _vm.pathwaysWithIgnore,
                          callback: function($$v) {
                            _vm.pathwaysWithIgnore = $$v
                          },
                          expression: "pathwaysWithIgnore"
                        }
                      }),
                      _vm._v(" "),
                      _vm.bundleObjectsList.length > 0
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "clear-button",
                              attrs: { small: "", text: "" },
                              on: { click: _vm.clearBundle }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticStyle: { "padding-right": "7px" } },
                                [_vm._v("clear_all")]
                              ),
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("ClearAll")) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "floating-objects-wrapper",
                      class: {
                        "bundle-direction-line": _vm.lineStringWKT.length > 1
                      },
                      staticStyle: { "margin-bottom": "5px" }
                    },
                    [
                      _c("CableSouthSVG", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.lineStringWKT.length > 1,
                            expression: "lineStringWKT.length > 1"
                          }
                        ],
                        staticStyle: {
                          position: "absolute",
                          left: "-6px",
                          bottom: "-4px"
                        }
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.bundleObjectsList, function(object, index) {
                        return _c(
                          "div",
                          {
                            key: object.uuid,
                            staticClass: "floating-object-selected"
                          },
                          [
                            object.type.toLowerCase() === "toby box"
                              ? _c("TobyBoxSVG", {
                                  staticClass: "floating-img"
                                })
                              : object.type.toLowerCase() === "cabinet"
                              ? _c("img", {
                                  staticClass: "floating-img",
                                  attrs: {
                                    src: require("@/assets/objectIcons/" +
                                      (object.type.toLowerCase() + "_t4") +
                                      ".png")
                                  }
                                })
                              : object.type.toLowerCase() === "virtual"
                              ? _c("VirtualSVG", {
                                  staticClass: "floating-img"
                                })
                              : _c("img", {
                                  staticClass: "floating-img",
                                  attrs: {
                                    src: require("@/assets/objectIcons/" +
                                      object.type.toLowerCase() +
                                      ".png")
                                  }
                                }),
                            _vm._v(" "),
                            object.uuid !== _vm.bundleObjectsList[0].uuid
                              ? _c("div", {
                                  staticClass: "floating-between-objects",
                                  style: { "border-color": "#FF00FF" }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-tooltip",
                              {
                                staticStyle: { display: "block" },
                                attrs: { top: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _vm.lineStringWKT[index].split
                                            ? _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticStyle: {
                                                      left: "-3px"
                                                    }
                                                  },
                                                  on
                                                ),
                                                [_vm._v("alt_route")]
                                              )
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("BundleSplitTooltip")))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "text-align": "left",
                                  "padding-right": "5px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.objectIdentification(object)) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "floating-hover-options",
                                on: {
                                  click: function($event) {
                                    return _vm.openBundleObjectMenu(
                                      $event,
                                      object
                                    )
                                  }
                                }
                              },
                              [_c("v-icon", [_vm._v("more_vert")])],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("home-window-button", {
              attrs: {
                label: _vm.bundleLabelButton,
                disabled: !_vm.bundle.creatable
              },
              on: { buttonClick: _vm.createBundle }
            }),
            _vm._v(" "),
            _c("loading-spinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "accent"
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            }),
            _vm._v(" "),
            _vm.bundleObjectMenu.open
              ? _c("window-object-menu", {
                  attrs: {
                    event: _vm.bundleObjectMenu.event,
                    object: _vm.bundleObjectMenu.object,
                    actionFrom: _vm.selectedToolObjectLayer
                  },
                  on: {
                    updateGeoServer: _vm.updateGeoServer,
                    closeMenu: _vm.closeBundleObjectMenu,
                    openForm: _vm.openFormFromBundleObjectMenu,
                    openDetailForm: function($event) {
                      return _vm.openFormFromBundleObjectMenu("detail")
                    },
                    removeFromCable: _vm.removeObjectFromBundle,
                    splitBundle: _vm.splitBundle
                  }
                })
              : _vm._e()
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d6dad76", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d6dad76","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Bundle/BundleWindow.vue
// module id = null
// module chunks = 